import md5 from 'md5'
import moment from 'moment'

import store from '@/store'

const hash = (user, pass) => md5(`${md5(user.toLowerCase())}ebc49f119ffc96b22a4e6994a99175b5${pass}`)

const formatTime = (time) => moment(time, 'X').format('YYYY-MM-DD HH:mm:ss(Z)')

const getServerNow = () => moment().subtract(store.state.timeDelta)

const getCountDown = (endTime, days) => {
  const ms = endTime.diff(getServerNow())
  const duration = moment.duration(ms)
  const hours = Math.floor(duration.asHours())
  if (hours < 0) return '0:00:00'
  if (hours > 48) return `${Math.floor(hours / 24)} ${days} ${parseInt(hours % 24, 10)}:${moment.utc(ms).format('mm:ss')}`
  return `${hours}:${moment.utc(ms).format('mm:ss')}`
}

const natural = (n) => {
  if (n === -1) return '?'
  else if (n === 0) return String.fromCharCode(8734)
  else return `${n} `
}

const getNetworkStatus = () => {
  const image = new Image()
  image.style.visibility = 'hidden'
  image.style.position = 'fixed'
  image.width = 1
  image.height = 1
  const randomNum = Math.round(Math.random() * 10000)
  // image.src = 'http://api.map.baidu.com/api?key=&v=1.1&services=true&rand=' + randomNum
  image.src = '//www.baidu.com/favicon.ico?rand=' + randomNum
  var done = false
  image.onload = function () {
    document.cookie = 'cdn=1'
    done = true
    console.log('image onload, done =', done)
  }
  image.onerror = function (e) {
    document.cookie = 'cdn=0'
    done = true
    console.log('image onerror, done =', done, e)
  }
  document.body.appendChild(image)
  setTimeout(() => {
    if (!done) {
      image.onload = null
      image.onerror = null
      image.src = '/favicon.ico'
      console.log('load image timeout, done =', done)
    }
  }, 3000)
}

const insertCustomCss = css => {
  if (!css) return console.log('invalid custom css')
  const style = document.createElement('style')
  style.type = 'text/css'
  style.appendChild(document.createTextNode(css))
  document.head.appendChild(style)
}

export { hash, formatTime, getServerNow, getCountDown, natural, getNetworkStatus, insertCustomCss }



// WEBPACK FOOTER //
// ./src/utils/index.js